// extracted by mini-css-extract-plugin
export var boldText = "_5e-4";
export var checkboxContainer = "_5e-6";
export var closeIcon = "_5e-i";
export var container = "_5e-0";
export var drawer = "_5e-8";
export var drawerContent = "_5e-9";
export var extraSmallText = "_5e-5";
export var fulfillmentGroupTable = "_5e-e";
export var largeText = "_5e-3";
export var loadingSpinnerContainer = "_5e-j";
export var mediumText = "_5e-2";
export var narrow = "_5e-f";
export var notificationLink = "_5e-l";
export var packageCheckIconContainer = "_5e-7";
export var slideoutHeaderActions = "_5e-g";
export var slideoutHeaderActionsShifted = "_5e-h";
export var slideoutHeaderContainer = "_5e-a";
export var slideoutModal = "_5e-c";
export var stickyHeaderWrapper = "_5e-b";
export var table = "_5e-k";
export var tableContainer = "_5e-d";
export var tertiaryText = "_5e-1";